import { defineMessages } from "react-intl";

export const messages = defineMessages({
  empty: {
    id: "FpIcp9",
    defaultMessage: "No vendors found",
  },
});

export const columnsMessages = defineMessages({
  name: {
    id: "nZDQbr",
    defaultMessage: "Vendor name",
    description: "column header",
  },
  email: {
    id: "945a4a",
    defaultMessage: "Vendor e-mail",
    description: "column header",
  },
  orders: {
    id: "MTGT8E",
    defaultMessage: "No. of orders",
    description: "column header",
  },
  actions: {
    id: "vendorActionsColumn",
    defaultMessage: "Actions",
    description: "vendor actions column header",
  },
});
